var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_479_1363)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "#EEF1F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9055 89.2431L70.4004 84.1038H60.0004H49.6004L31.0953 89.2448C23.5917 91.3283 18.4004 98.1594 18.4004 105.945V124H60.0004H101.6V105.945C101.6 98.1594 96.4091 91.3283 88.9055 89.2431Z",
    fill: "#6E83B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1338 85.0658L54.8005 124H65.2005L73.8671 85.0658L70.4005 84.1038H49.6005L46.1338 85.0658Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2666 117.067H35.7333V124H32.2666V117.067Z",
    fill: "#466089"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2666 117.067H87.7333V124H84.2666V117.067Z",
    fill: "#466089"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4006 71.9705H49.6006V84.1038L49.6023 84.1055C49.6023 84.1142 49.6006 84.1229 49.6006 84.1333C49.6006 89.8775 54.2563 94.5333 60.0006 94.5333C65.7449 94.5333 70.4006 89.8775 70.4006 84.1333C70.4006 84.1229 70.3989 84.1142 70.3989 84.1038H70.4006V71.9705Z",
    fill: "#FCB98B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7992 40.7705V58.1333C80.7992 69.6201 71.486 78.9333 59.9992 78.9333C48.5124 78.9333 39.1992 69.6201 39.1992 58.1333V40.7705H80.7992Z",
    fill: "#FFD3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7998 46H82.001C84.1105 46 85.7311 47.8685 85.433 49.9589L84.6929 55.1295C84.4485 56.8368 82.9855 58.1039 81.2609 58.1039H80.7998V46Z",
    fill: "#FFD3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1999 46H37.9987C35.8892 46 34.2686 47.8685 34.5667 49.9589L35.3068 55.1295C35.5512 56.8368 37.0142 58.1039 38.7388 58.1039H39.1999V46Z",
    fill: "#FFD3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8002 58.1039L77.3335 44.2372H60.0002H42.6669L39.2002 58.1039V37.3333C39.2002 27.7601 46.9603 20 56.5335 20H65.2002C69.0291 20 72.1335 23.1044 72.1335 26.9333C76.9193 26.9333 80.8002 30.8143 80.8002 35.6V58.1039Z",
    fill: "#6E83B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6005 80.6667L60.0005 92.8001L53.0671 99.7334L46.1338 85.0659L49.6005 80.6667Z",
    fill: "#EDEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4 80.6667L60 92.8001L66.9333 99.7334L73.8667 85.0659L70.4 80.6667Z",
    fill: "#EDEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2008 98L60.0008 92.8L54.8008 98L58.2674 103.2L54.8008 124H60.0008H65.2008L61.7341 103.2L65.2008 98Z",
    fill: "#FFB0AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8669 85.0657L65.2002 124H75.6002L73.8669 106.666L79.0669 94.5331L73.8669 85.0657Z",
    fill: "#466089"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1336 85.0657L54.8003 124H44.4003L46.1336 106.666L40.9336 94.5331L46.1336 85.0657Z",
    fill: "#466089"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_479_1363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.0ede2873138f3d8957504c6326106109.svg";
export { ForwardRef as ReactComponent };